/**
 * @copyright WaterStreet. All rights reserved.
 */

import {
	Component
} from '@angular/core';
import {
	PageContextDirective
} from '@shared/directives/page-context.directive';
import {
	ResolverService
} from '@shared/services/resolver.service';

@Component({
	selector: 'app-styles',
	templateUrl: './styles.component.html'
})

/**
 * A component representing an instance of the user interface styles
 * component.
 *
 * @export
 * @class StylesComponent
 * @extends {PageContextDirective}
 */
export class StylesComponent
	extends PageContextDirective
{
	/**
	 * Creates an instance of the styles component.
	 *
	 * @param {ResolverService} resolver
	 * The resolver service used for dynamic logic and business rules.
	 * @memberof StylesComponent
	 */
	public constructor(
		public resolver: ResolverService)
	{
		super(resolver);
	}
}